import { authHeaders } from '../../shared/authHeaders';

type Fetcher = (input: RequestInfo | URL, init?: RequestInit) => Promise<Response>;

export async function uploadRoomArtwork(
  roomCode: string,
  formData: FormData,
  authToken: string | null | undefined,
  fetcher: Fetcher = fetch,
): Promise<void> {
  const response = await fetcher(`/api/rooms/${roomCode}/artwork`, {
    method: 'POST',
    headers: authHeaders(authToken),
    body: formData,
  });

  if (!response.ok) {
    throw new Error('Upload failed');
  }
}
